import type { SearchCarriersParams } from './carrier.api';

export const carrierKeys = {
  all: ['carriers'] as const,
  detail: (carrierId: string): readonly unknown[] => [...carrierKeys.all, 'detail', carrierId] as const,
  list: (params: SearchCarriersParams): readonly unknown[] => [...carrierKeys.lists(), params] as const,
  lists: (): readonly string[] => [...carrierKeys.all, 'list'] as const,
};
